// extracted by extract-css-chunks-webpack-plugin
module.exports = {"react-notification":"notification__react-notification--1xPeV","reactNotification":"notification__react-notification--1xPeV"};